export class ShiftScheduleModel {
    ShiftScheduleId: number;
    DayOfWeek: string;
    StartTime: string;
    EndTime: string;
    ShiftDescription: string;
    LineName: string;
    ShiftDescriptionTDV: string;
    ShiftEndDate: Date;
    ShiftStartDate: Date;

    constructor(obj: any){
        this.ShiftScheduleId = obj?.ShiftScheduleId ?? obj?.shiftScheduleId ?? 0;
        this.DayOfWeek = obj?.DayOfWeek ?? obj?.dayOfWeek ?? '';
        this.StartTime = obj?.StartTime ?? obj?.startTime ?? '';
        this.EndTime = obj?.EndTime ?? obj?.endTime ?? '';
        this.ShiftDescription = obj?.ShiftDescription ?? obj?.shiftDescription ?? '';
        this.LineName = obj?.LineName ?? obj?.lineName ?? '';
        this.ShiftDescriptionTDV = obj?.ShiftDescriptionTDV ?? obj?.shiftDescriptionTDV ?? '';
        this.ShiftEndDate = obj?.ShiftEndDate ?? obj?.shiftEndDate ?? new Date();
        this.ShiftStartDate = obj?.ShiftEndDate ?? obj?.shiftEndDate ?? new Date();
    }
}